import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import React from "react";
import DataTable from "../components/DataTable";
import { hostname } from "../hooks/useEndeavour";
import { Link, useNavigate } from "react-router-dom";
import { timestampToLocalTime } from "anka-endeavour";
import DateRangePicker from "../components/DateRangePicker";
import Status from "../components/Status";

function TransactionsPage() {
  const navigate = useNavigate();
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <DataTable
          uri={`${hostname}/pa-alliance/transactions`}
          // tableTitle={'Transactions'}
          name="Transactions"
          filters={[
            <Form.Item name={"user"} label="User Email" key="user">
              <Input placeholder="User Email" />
            </Form.Item>,
            <Form.Item name={"card_transaction_uuid"} label="Card Transaction UUID" key="card_transaction_uuid">
              <Input placeholder="Filter by UUID" />
            </Form.Item>,
            <Form.Item name={"type"} label={"Type"} key="type">
              <Select placeholder="Select Type" allowClear>
                <Select.Option value="CREDIT">CREDIT</Select.Option>
                <Select.Option value="DEBIT">DEBIT</Select.Option>
              </Select>
            </Form.Item>,
            <Form.Item name={"created_at"} label="Created At" key="created_at">
              <DateRangePicker />
            </Form.Item>,
          ]}
          tableColumns={[
            {
              title: "Card Transaction UUID",
              render: (data) => {
                return data.card_transaction_uuid;
                //   <a href={`/transaction/${data?.card_transaction_uuid}`} target="_blank">
                //     {data?.card_transaction_uuid}
                //   </a>
              },
            },
            {
              title: "Ref Id",
              render: (data) => {
                return data.ref_id;
                //   <a href={`/transaction/${data?.card_transaction_uuid}`} target="_blank">
                //     {data?.card_transaction_uuid}
                //   </a>
              },
            },
            {
              title: "User Email",
              render: (data) => {
                return data?.user_email;
              },
            },
            {
              title: "Last 4",
              render: (data) => {
                return data?.card_info?.last4;
              },
            },
            {
              title: "Card Status",
              render: (data) => {
                if (data?.card_info?.card_status === null) {
                  return "-";
                }
                return <Status value={data?.card_info?.card_status} />;
              },
            },
            {
              title: "Type",
              render: (data) => {
                return data?.type;
              },
            },
            {
              title: "Status",
              render: (data) => {
                if (data?.status === null) {
                  return "-";
                }
                return <Status value={data?.status} />;
              },
            },

            {
              title: "Merchant Name",
              render: (data) => {
                return data?.merchant_name;
              },
            },
            {
              title: "Merchant Category",
              render: (data) => {
                return data?.merchant_category;
              },
            },
            {
              title: "Amount",
              render: (data) => {
                return data?.currency + parseFloat(data?.amount).toFixed(2);
              },
            },
            {
              title: "Authorization Response",
              render: (data) => {
                return data?.authorization_response_message;
              },
            },

            {
              title: "Create Date",
              render: (data) => {
                return timestampToLocalTime(data.created_at);
              },
            },
          ]}
        />
      </Col>
    </Row>
  );
}

export default TransactionsPage;
